import './Notifications.scss';

export { default } from './Notifications';
